'use client'

import { useEffect } from 'react'

/**
 * Registers the PulseSignal service worker (NB-F259).
 *
 * Mounted once from the root layout. Registration is deferred to the
 * `load` event so it never competes with first-paint work, and is
 * skipped entirely in development (`NODE_ENV !== 'production'`) to keep
 * Next.js HMR/Fast Refresh from being intercepted by cached responses.
 */
export default function ServiceWorkerRegister() {
  useEffect(() => {
    if (typeof window === 'undefined') return
    if (!('serviceWorker' in navigator)) return
    if (process.env.NODE_ENV !== 'production') return

    const register = () => {
      navigator.serviceWorker
        .register('/sw.js', { scope: '/' })
        .catch((err) => {
          // Swallow it: SW failure must never break the app. We log to the
          // console (Sentry breadcrumbs will pick this up via the
          // existing ObservabilityBoot console-capture).
          // eslint-disable-next-line no-console
          console.warn('[sw] registration failed', err)
        })
    }

    if (document.readyState === 'complete') {
      register()
    } else {
      window.addEventListener('load', register, { once: true })
      return () => window.removeEventListener('load', register)
    }
  }, [])

  return null
}
